import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  VelocityLimitListState,
  VELOCITY_LIMIT_LIST_STATE,
} from './velocity-limit-list.state';

export const selectVelocityLimit =
  createFeatureSelector<VelocityLimitListState>(VELOCITY_LIMIT_LIST_STATE);

export const selectVelocityLimitList = createSelector(
  selectVelocityLimit,
  (state: VelocityLimitListState) => {
    return state.dataSource;
  }
);

export const selectVelocityLimitListFilter = createSelector(
  selectVelocityLimit,
  (state: VelocityLimitListState) => state.filter
);
